import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  RESET_USER_PASSWORD,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  RESET_USER_PASSWORD_SUCCESS,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const resetPassword = (user, history) => {
  return {
    type: RESET_USER_PASSWORD,
    payload: { user, history },
  }
}

export const resetPasswordSuccess = (user, history) => {
  return {
    type: RESET_USER_PASSWORD_SUCCESS,
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}
